var path = 'app/core/views/settingsBlockTabContent.html';
var html = "<div class=\"clearfix\" ng-show=\"selected\" ng-transclude></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;